import { useTranslation } from 'react-i18next';

import Button from '../../ui/Button';
import Modal from '../../ui/Modal';

import classes from './LogoutModal.module.css';

type LogoutModalProps = {
  onCancel: () => void;
  onLogout: () => void;
};

const LogoutModal = (props: LogoutModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={props.onCancel}>
      <p>{t('modals.logout')}</p>
      <div className={classes.buttons}>
        <Button onClick={props.onCancel}>{t('buttons.no')}</Button>
        <Button onClick={props.onLogout}>{t('buttons.yes')}</Button>
      </div>
    </Modal>
  );
};

export default LogoutModal;
